var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomMobileResultPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 501,
    opacity: 0.8,
    viewBox: "0 0 413 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.656 106.37C412.661 92.8866 415.692 76.0486 409.887 63.3691C398.04 37.5059 363.396 32.2148 345.731 54.1197C340.334 60.8156 334.933 68.312 326.79 71.0777C311.596 76.2327 296.137 67.5636 280.771 75.6604C264.396 84.2895 252.877 102.124 233.772 105.47C222.193 107.499 211.743 103.173 200.649 104.357C195.124 104.946 189.443 106.19 185.067 109.612C173.548 118.626 176.19 137.149 183.277 147.803C188.838 156.16 197.162 162.448 206.29 166.634C227.062 176.164 250.723 171.129 272.516 168.403C285.576 166.77 298.115 164.141 311.111 162.5C325.569 160.678 339.97 157.785 353.623 152.59C372.188 145.53 389.476 133.911 400.574 117.441C402.764 114.191 404.846 110.433 406.656 106.366V106.37Z",
    fill: "#67CFEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.238 85.1706C49.8576 86.3633 49.5734 87.576 49.3812 88.8047L51.6273 86.5594L55.8912 82.2968L60.1552 78.0343L64.4191 73.7718L68.6831 69.5093L69.6079 68.5848C69.0874 68.6648 68.5669 68.7649 68.0505 68.8769C66.5291 69.2171 65.0357 69.7014 63.5903 70.3378L62.2891 71.6386L58.0252 75.9011L53.7612 80.1636L51.1428 82.7851C50.7985 83.5656 50.4982 84.3621 50.242 85.1666L50.238 85.1706Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6272 95.0805L55.8912 90.818L60.1552 86.5555L64.4191 82.293L68.683 78.0304L72.947 73.7679L77.2109 69.5054L77.9836 68.733C77.3751 68.6169 76.7665 68.5249 76.1539 68.4528C75.4893 68.3768 74.8207 68.3288 74.1521 68.3047L70.817 71.6387L66.5531 75.9012L62.2891 80.1637L58.0252 84.4262L53.7612 88.6887L49.4973 92.9512L49.1049 93.3435C49.145 94.6282 49.2891 95.909 49.5333 97.1777L51.6272 95.0845V95.0805Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8872 99.3391L60.1511 95.0766L64.4151 90.8141L68.679 86.5516L72.943 82.2891L77.2069 78.0265L81.4709 73.7641L84.3335 70.9024C83.3606 70.4101 82.3637 69.9858 81.3427 69.6296L79.3409 71.6308L75.0769 75.8933L70.813 80.1558L66.549 84.4183L62.2851 88.6808L58.0212 92.9433L53.7572 97.2059L50.4341 100.528C50.7865 101.544 51.2108 102.545 51.7073 103.518L55.8872 99.3391Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8871 107.859L60.1511 103.597L64.415 99.3344L68.679 95.0719L72.9429 90.8094L77.2068 86.5469L81.4708 82.2844L85.7347 78.0219L89.4102 74.3477C88.6414 73.6673 87.8407 73.0469 87.0119 72.4826L83.6048 75.8886L79.3408 80.1511L75.0769 84.4137L70.8129 88.6761L66.549 92.9387L62.2851 97.2012L58.0211 101.464L53.7571 105.726L53.2927 106.19C53.8572 107.019 54.4778 107.819 55.1584 108.588L55.8911 107.855L55.8871 107.859Z",
    fill: "#FFDE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1511 112.123L64.4151 107.86L68.679 103.598L72.943 99.335L77.2069 95.0725L81.4709 90.81L85.7348 86.5475L89.9987 82.285L93.4099 78.8749C92.8454 78.0464 92.2208 77.25 91.5442 76.4815L87.8688 80.1557L83.6048 84.4182L79.3409 88.6807L75.0769 92.9432L70.813 97.2058L66.549 101.468L62.2851 105.731L58.0212 109.993L57.2885 110.726C58.0572 111.406 58.8539 112.026 59.6827 112.591L60.1511 112.123Z",
    fill: "#FFDE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.675 112.122L72.939 107.86L77.2029 103.597L81.4669 99.3346L85.7308 95.0721L89.9948 90.8096L94.2587 86.5471L96.2686 84.5379C95.9122 83.5213 95.4878 82.5247 94.9954 81.5522L92.1287 84.4179L87.8648 88.6803L83.6009 92.9429L79.3369 97.2054L75.0729 101.468L70.809 105.73L66.5451 109.993L62.3572 114.179C63.3301 114.672 64.327 115.1 65.3439 115.452L68.675 112.122Z",
    fill: "#FFDE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.935 116.381L77.1989 112.118L81.4629 107.856L85.7268 103.593L89.9908 99.3308L94.2547 95.0683L97.6018 91.7223C97.5778 91.0619 97.5297 90.4055 97.4577 89.7491C97.3856 89.1288 97.2895 88.5084 97.1734 87.892L96.3887 88.6765L92.1247 92.939L87.8608 97.2015L83.5969 101.464L79.3329 105.727L75.069 109.989L70.805 114.252L68.6991 116.357C69.9642 116.601 71.2454 116.745 72.5306 116.789L72.935 116.385V116.381Z",
    fill: "#FFDE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0604 114.783L85.7229 112.122L89.9868 107.859L94.2507 103.597L95.592 102.256C96.2165 100.827 96.693 99.3544 97.0293 97.8535C97.1454 97.3252 97.2455 96.7929 97.3296 96.2606L96.3847 97.2051L92.1208 101.468L87.8568 105.73L83.5929 109.993L79.3289 114.255L77.0628 116.521C78.304 116.328 79.5291 116.044 80.7342 115.66C81.519 115.408 82.2957 115.12 83.0604 114.787V114.783Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.992 87.4679C199.836 86.6234 199.848 85.2666 199.032 84.4061C198.343 85.6108 197.722 86.8395 197.162 88.0922C197.814 88.1763 198.495 87.9682 198.996 87.4679H198.992Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 81.2561C202.955 82.1126 204.345 82.1126 205.205 81.2561C206.062 80.3996 206.062 79.0067 205.205 78.1502C204.841 77.786 204.385 77.5779 203.908 77.5258C203.087 78.4744 202.311 79.447 201.586 80.4476C201.694 80.7437 201.862 81.0199 202.098 81.2601V81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.312 75.0441C209.169 75.9006 210.558 75.9006 211.419 75.0441C212.276 74.1876 212.276 72.7948 211.419 71.9383C211.147 71.6662 210.819 71.478 210.47 71.382C209.517 72.1064 208.585 72.8749 207.68 73.6873C207.724 74.1836 207.936 74.6679 208.316 75.0441H208.312Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 68.8322C215.383 69.6887 216.772 69.6887 217.633 68.8322C218.21 68.2559 218.398 67.4434 218.198 66.711C216.912 67.3114 215.651 67.9797 214.418 68.7161C214.454 68.7562 214.486 68.7962 214.526 68.8322Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.415 104.454C193.415 104.566 193.407 104.674 193.407 104.786C193.419 104.674 193.423 104.566 193.415 104.454Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.992 99.8908C199.848 99.0343 199.848 97.6415 198.992 96.785C198.135 95.9285 196.742 95.9285 195.885 96.785C195.028 97.6415 195.028 99.0343 195.885 99.8908C196.742 100.747 198.131 100.747 198.992 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.205 93.6789C206.062 92.8224 206.062 91.4296 205.205 90.5731C204.349 89.7166 202.955 89.7166 202.098 90.5731C201.242 91.4296 201.242 92.8224 202.098 93.6789C202.955 94.5354 204.345 94.5354 205.205 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.419 87.468C212.276 86.6115 212.276 85.2186 211.419 84.3621C210.562 83.5056 209.169 83.5056 208.312 84.3621C207.456 85.2186 207.456 86.6115 208.312 87.468C209.169 88.3245 210.558 88.3245 211.419 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.633 81.2561C218.49 80.3996 218.49 79.0067 217.633 78.1502C216.776 77.2937 215.383 77.2937 214.526 78.1502C213.669 79.0067 213.669 80.3996 214.526 81.2561C215.383 82.1126 216.772 82.1126 217.633 81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.847 75.0441C224.703 74.1876 224.703 72.7948 223.847 71.9383C222.99 71.0818 221.597 71.0818 220.74 71.9383C219.883 72.7948 219.883 74.1876 220.74 75.0441C221.597 75.9006 222.986 75.9006 223.847 75.0441Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.06 68.8322C230.917 67.9757 230.917 66.5829 230.06 65.7264C229.203 64.8699 227.81 64.8699 226.953 65.7264C226.097 66.5829 226.097 67.9757 226.953 68.8322C227.814 69.6887 229.199 69.6887 230.06 68.8322Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M236.23 62.6613C235.265 62.6653 234.296 62.7014 233.331 62.7734C234.18 63.4658 235.421 63.4298 236.23 62.6613Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.885 112.315C196.742 113.171 198.131 113.171 198.992 112.315C199.848 111.458 199.848 110.065 198.992 109.209C198.135 108.352 196.742 108.352 195.885 109.209C195.028 110.065 195.028 111.458 195.885 112.315Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 106.103C202.955 106.959 204.345 106.959 205.205 106.103C206.062 105.246 206.062 103.853 205.205 102.997C204.349 102.14 202.955 102.14 202.098 102.997C201.242 103.853 201.242 105.246 202.098 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M208.312 99.8908C209.169 100.747 210.558 100.747 211.419 99.8908C212.276 99.0343 212.276 97.6415 211.419 96.785C210.562 95.9285 209.169 95.9285 208.312 96.785C207.456 97.6415 207.456 99.0343 208.312 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 93.6789C215.383 94.5354 216.772 94.5354 217.633 93.6789C218.49 92.8224 218.49 91.4296 217.633 90.5731C216.776 89.7166 215.383 89.7166 214.526 90.5731C213.669 91.4296 213.669 92.8224 214.526 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 87.468C221.597 88.3245 222.986 88.3245 223.847 87.468C224.703 86.6115 224.703 85.2186 223.847 84.3621C222.99 83.5056 221.597 83.5056 220.74 84.3621C219.883 85.2186 219.883 86.6115 220.74 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 81.2561C227.814 82.1126 229.199 82.1126 230.06 81.2561C230.917 80.3996 230.917 79.0067 230.06 78.1502C229.203 77.2937 227.81 77.2937 226.953 78.1502C226.097 79.0067 226.097 80.3996 226.953 81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M236.274 75.0441C237.131 74.1876 237.131 72.7948 236.274 71.9383C235.413 71.0818 234.024 71.0818 233.167 71.9383C232.31 72.7948 232.31 74.1876 233.167 75.0441C234.024 75.9006 235.413 75.9006 236.274 75.0441Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242.488 68.8322C243.345 67.9757 243.345 66.5829 242.488 65.7264C241.631 64.8699 240.238 64.8699 239.381 65.7264C238.524 66.5829 238.524 67.9757 239.381 68.8322C240.238 69.6887 241.627 69.6887 242.488 68.8322Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.992 121.632C198.263 120.904 197.154 120.796 196.309 121.304C196.834 122.653 197.426 123.981 198.091 125.282C198.419 125.178 198.731 124.998 198.992 124.738C199.848 123.881 199.848 122.489 198.992 121.632Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 118.526C202.955 119.382 204.345 119.382 205.205 118.526C206.062 117.669 206.062 116.276 205.205 115.42C204.349 114.563 202.955 114.563 202.098 115.42C201.242 116.276 201.242 117.669 202.098 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M208.312 112.315C209.169 113.171 210.558 113.171 211.419 112.315C212.276 111.458 212.276 110.065 211.419 109.209C210.562 108.352 209.169 108.352 208.312 109.209C207.456 110.065 207.456 111.458 208.312 112.315Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 106.103C215.383 106.959 216.772 106.959 217.633 106.103C218.49 105.246 218.49 103.853 217.633 102.997C216.776 102.14 215.383 102.14 214.526 102.997C213.669 103.853 213.669 105.246 214.526 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 99.8908C221.597 100.747 222.986 100.747 223.847 99.8908C224.703 99.0343 224.703 97.6415 223.847 96.785C222.99 95.9285 221.597 95.9285 220.74 96.785C219.883 97.6415 219.883 99.0343 220.74 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 93.6789C227.814 94.5354 229.199 94.5354 230.06 93.6789C230.917 92.8224 230.917 91.4296 230.06 90.5731C229.203 89.7166 227.81 89.7166 226.953 90.5731C226.097 91.4296 226.097 92.8224 226.953 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 87.468C234.024 88.3245 235.413 88.3245 236.274 87.468C237.131 86.6115 237.131 85.2186 236.274 84.3621C235.413 83.5056 234.024 83.5056 233.167 84.3621C232.31 85.2186 232.31 86.6115 233.167 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 81.2561C240.238 82.1126 241.627 82.1126 242.488 81.2561C243.345 80.3996 243.345 79.0067 242.488 78.1502C241.631 77.2937 240.238 77.2937 239.381 78.1502C238.524 79.0067 238.524 80.3996 239.381 81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M248.702 75.0441C249.558 74.1876 249.558 72.7948 248.702 71.9383C247.845 71.0818 246.452 71.0818 245.595 71.9383C244.738 72.7948 244.738 74.1876 245.595 75.0441C246.452 75.9006 247.841 75.9006 248.702 75.0441Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M251.804 65.7264C250.948 66.5829 250.948 67.9757 251.804 68.8322C252.661 69.6887 254.051 69.6887 254.911 68.8322C255.388 68.356 255.596 67.7196 255.548 67.0992C254.387 66.5269 253.206 66.0106 252.009 65.5503C251.937 65.6063 251.869 65.6624 251.804 65.7304V65.7264Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 130.949C202.955 131.806 204.345 131.806 205.205 130.949C206.062 130.093 206.062 128.7 205.205 127.844C204.349 126.987 202.955 126.987 202.098 127.844C201.242 128.7 201.242 130.093 202.098 130.949Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.312 124.738C209.169 125.594 210.558 125.594 211.419 124.738C212.276 123.881 212.276 122.488 211.419 121.632C210.562 120.775 209.169 120.775 208.312 121.632C207.456 122.488 207.456 123.881 208.312 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 118.526C215.383 119.382 216.772 119.382 217.633 118.526C218.49 117.669 218.49 116.276 217.633 115.42C216.776 114.563 215.383 114.563 214.526 115.42C213.669 116.276 213.669 117.669 214.526 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 112.315C221.597 113.171 222.986 113.171 223.847 112.315C224.703 111.458 224.703 110.065 223.847 109.209C222.99 108.352 221.597 108.352 220.74 109.209C219.883 110.065 219.883 111.458 220.74 112.315Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 106.103C227.81 106.959 229.199 106.959 230.06 106.103C230.917 105.246 230.917 103.853 230.06 102.997C229.203 102.14 227.81 102.14 226.953 102.997C226.097 103.853 226.097 105.246 226.953 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 99.8908C234.024 100.747 235.413 100.747 236.274 99.8908C237.131 99.0343 237.131 97.6415 236.274 96.785C235.413 95.9285 234.024 95.9285 233.167 96.785C232.31 97.6415 232.31 99.0343 233.167 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 93.6789C240.238 94.5354 241.627 94.5354 242.488 93.6789C243.345 92.8224 243.345 91.4296 242.488 90.5731C241.631 89.7166 240.238 89.7166 239.381 90.5731C238.524 91.4296 238.524 92.8224 239.381 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M245.595 87.468C246.452 88.3245 247.841 88.3245 248.702 87.468C249.558 86.6115 249.558 85.2186 248.702 84.3621C247.845 83.5056 246.452 83.5056 245.595 84.3621C244.738 85.2186 244.738 86.6115 245.595 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M254.911 81.2561C255.768 80.3996 255.768 79.0067 254.911 78.1502C254.055 77.2937 252.665 77.2937 251.804 78.1502C250.948 79.0067 250.948 80.3996 251.804 81.2561C252.661 82.1126 254.051 82.1126 254.911 81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M261.129 75.0441C261.986 74.1876 261.986 72.7948 261.129 71.9383C260.272 71.0818 258.879 71.0818 258.022 71.9383C257.165 72.7948 257.165 74.1876 258.022 75.0441C258.879 75.9006 260.268 75.9006 261.129 75.0441Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M208.312 137.161C209.169 138.018 210.558 138.018 211.419 137.161C212.276 136.305 212.276 134.912 211.419 134.055C210.562 133.199 209.169 133.199 208.312 134.055C207.456 134.916 207.456 136.305 208.312 137.161Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 130.949C215.383 131.806 216.772 131.806 217.633 130.949C218.49 130.093 218.49 128.7 217.633 127.844C216.776 126.987 215.383 126.987 214.526 127.844C213.669 128.7 213.669 130.093 214.526 130.949Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 124.738C221.597 125.594 222.986 125.594 223.847 124.738C224.703 123.881 224.703 122.488 223.847 121.632C222.99 120.775 221.597 120.775 220.74 121.632C219.883 122.488 219.883 123.881 220.74 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 118.526C227.81 119.382 229.199 119.382 230.06 118.526C230.917 117.669 230.917 116.276 230.06 115.42C229.203 114.563 227.81 114.563 226.953 115.42C226.097 116.276 226.097 117.669 226.953 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 112.315C234.024 113.171 235.413 113.171 236.274 112.315C237.131 111.458 237.131 110.065 236.274 109.209C235.413 108.352 234.024 108.352 233.167 109.209C232.31 110.065 232.31 111.458 233.167 112.315Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 106.103C240.238 106.959 241.627 106.959 242.488 106.103C243.345 105.246 243.345 103.853 242.488 102.997C241.631 102.14 240.238 102.14 239.381 102.997C238.524 103.853 238.524 105.246 239.381 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M245.595 99.8908C246.451 100.747 247.841 100.747 248.702 99.8908C249.562 99.0343 249.562 97.6415 248.702 96.785C247.845 95.9285 246.451 95.9285 245.595 96.785C244.738 97.6415 244.738 99.0343 245.595 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 93.6789C252.665 94.5354 254.055 94.5354 254.916 93.6789C255.772 92.8224 255.772 91.4296 254.916 90.5731C254.059 89.7166 252.669 89.7166 251.809 90.5731C250.952 91.4296 250.952 92.8224 251.809 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M258.022 87.468C258.879 88.3245 260.268 88.3245 261.129 87.468C261.986 86.6115 261.986 85.2186 261.129 84.3621C260.272 83.5056 258.879 83.5056 258.022 84.3621C257.165 85.2186 257.165 86.6115 258.022 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M267.343 81.2561C268.2 80.3996 268.2 79.0067 267.343 78.1502C266.486 77.2937 265.093 77.2937 264.236 78.1502C263.379 79.0067 263.379 80.3996 264.236 81.2561C265.093 82.1126 266.482 82.1126 267.343 81.2561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M217.633 140.263C216.776 139.407 215.383 139.407 214.526 140.263C213.937 140.852 213.753 141.696 213.973 142.441C214.842 142.973 215.727 143.473 216.628 143.941C216.996 143.845 217.345 143.657 217.633 143.369C218.49 142.513 218.49 141.12 217.633 140.263Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 137.156C221.597 138.013 222.986 138.013 223.847 137.156C224.703 136.3 224.703 134.907 223.847 134.051C222.99 133.194 221.597 133.194 220.74 134.051C219.883 134.907 219.883 136.3 220.74 137.156Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 130.949C227.81 131.806 229.199 131.806 230.06 130.949C230.917 130.093 230.917 128.7 230.06 127.844C229.203 126.987 227.81 126.987 226.953 127.844C226.097 128.7 226.097 130.093 226.953 130.949Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 124.738C234.024 125.594 235.413 125.594 236.274 124.738C237.131 123.881 237.131 122.488 236.274 121.632C235.413 120.775 234.024 120.775 233.167 121.632C232.31 122.488 232.31 123.881 233.167 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 118.526C240.238 119.382 241.627 119.382 242.488 118.526C243.345 117.669 243.345 116.276 242.488 115.42C241.631 114.563 240.238 114.563 239.381 115.42C238.524 116.276 238.524 117.669 239.381 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M245.595 112.315C246.451 113.171 247.841 113.171 248.702 112.315C249.562 111.458 249.562 110.065 248.702 109.209C247.845 108.352 246.451 108.352 245.595 109.209C244.738 110.065 244.738 111.458 245.595 112.315Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 106.103C252.665 106.959 254.055 106.959 254.916 106.103C255.772 105.246 255.772 103.853 254.916 102.997C254.059 102.14 252.669 102.14 251.809 102.997C250.952 103.853 250.952 105.246 251.809 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M258.022 99.8908C258.879 100.747 260.268 100.747 261.129 99.8908C261.986 99.0343 261.986 97.6415 261.129 96.785C260.272 95.9285 258.879 95.9285 258.022 96.785C257.165 97.6415 257.165 99.0343 258.022 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M264.236 93.6789C265.093 94.5354 266.482 94.5354 267.343 93.6789C268.2 92.8224 268.2 91.4296 267.343 90.5731C266.486 89.7166 265.093 89.7166 264.236 90.5731C263.379 91.4296 263.379 92.8224 264.236 93.6789Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M273.553 87.468C274.41 86.6115 274.41 85.2186 273.553 84.3621C272.696 83.5056 271.303 83.5056 270.446 84.3621C269.589 85.2186 269.589 86.6115 270.446 87.468C271.303 88.3245 272.692 88.3245 273.553 87.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M223.847 146.475C223.174 145.802 222.169 145.658 221.356 146.042C222.309 146.398 223.27 146.719 224.239 147.007C224.139 146.815 224.007 146.635 223.847 146.475Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M226.953 143.368C227.81 144.229 229.199 144.229 230.06 143.368C230.917 142.512 230.917 141.119 230.06 140.262C229.203 139.406 227.81 139.406 226.953 140.262C226.097 141.119 226.097 142.512 226.953 143.368Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 137.156C234.024 138.013 235.413 138.013 236.274 137.156C237.131 136.3 237.131 134.907 236.274 134.051C235.413 133.194 234.024 133.194 233.167 134.051C232.31 134.907 232.31 136.3 233.167 137.156Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 130.949C240.238 131.806 241.627 131.806 242.488 130.949C243.345 130.093 243.345 128.7 242.488 127.844C241.631 126.987 240.238 126.987 239.381 127.844C238.524 128.7 238.524 130.093 239.381 130.949Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M245.595 124.738C246.451 125.594 247.841 125.594 248.702 124.738C249.562 123.881 249.562 122.488 248.702 121.632C247.845 120.775 246.451 120.775 245.595 121.632C244.738 122.488 244.738 123.881 245.595 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 118.526C252.665 119.382 254.055 119.382 254.916 118.526C255.772 117.669 255.772 116.276 254.916 115.42C254.059 114.563 252.669 114.563 251.809 115.42C250.952 116.276 250.952 117.669 251.809 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M258.022 112.311C258.879 113.167 260.268 113.167 261.129 112.311C261.986 111.454 261.986 110.061 261.129 109.205C260.272 108.348 258.879 108.348 258.022 109.205C257.165 110.061 257.165 111.454 258.022 112.311Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M264.232 106.103C265.089 106.959 266.478 106.959 267.339 106.103C268.196 105.246 268.196 103.853 267.339 102.997C266.482 102.14 265.089 102.14 264.232 102.997C263.375 103.853 263.375 105.246 264.232 106.103Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M270.45 99.8908C271.307 100.747 272.696 100.747 273.557 99.8908C274.413 99.0343 274.413 97.6415 273.557 96.785C272.7 95.9285 271.307 95.9285 270.45 96.785C269.593 97.6415 269.593 99.0343 270.45 99.8908Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M276.659 93.6791C277.036 94.0554 277.516 94.2675 278.005 94.3115C277.652 93.0188 277.236 91.742 276.759 90.4773C276.723 90.5093 276.691 90.5373 276.655 90.5693C275.799 91.4258 275.799 92.8186 276.655 93.6751L276.659 93.6791Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M236.274 146.474C235.413 145.618 234.024 145.618 233.167 146.474C232.591 147.051 232.407 147.863 232.603 148.596C233.996 148.72 235.393 148.776 236.791 148.768C237.067 147.991 236.899 147.095 236.278 146.474H236.274Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M239.381 143.368C240.238 144.229 241.627 144.229 242.488 143.368C243.345 142.512 243.345 141.119 242.488 140.262C241.631 139.406 240.238 139.406 239.381 140.262C238.524 141.119 238.524 142.512 239.381 143.368Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M245.595 137.156C246.451 138.013 247.841 138.013 248.702 137.156C249.562 136.3 249.562 134.907 248.702 134.051C247.845 133.194 246.451 133.194 245.595 134.051C244.738 134.907 244.738 136.3 245.595 137.156Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 130.946C252.665 131.802 254.055 131.802 254.916 130.946C255.772 130.089 255.772 128.696 254.916 127.84C254.059 126.983 252.669 126.983 251.809 127.84C250.952 128.696 250.952 130.089 251.809 130.946Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M258.022 124.738C258.879 125.594 260.268 125.594 261.129 124.738C261.986 123.881 261.986 122.488 261.129 121.632C260.272 120.775 258.879 120.775 258.022 121.632C257.165 122.488 257.165 123.881 258.022 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M264.232 118.526C265.089 119.382 266.478 119.382 267.339 118.526C268.196 117.669 268.196 116.276 267.339 115.42C266.482 114.563 265.089 114.563 264.232 115.42C263.375 116.276 263.375 117.669 264.232 118.526Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M270.45 112.311C271.307 113.167 272.696 113.167 273.557 112.311C274.413 111.454 274.413 110.061 273.557 109.205C272.7 108.348 271.307 108.348 270.45 109.205C269.593 110.061 269.593 111.454 270.45 112.311Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M276.66 106.102C277.444 106.887 278.669 106.951 279.53 106.302C279.546 105.11 279.514 103.913 279.434 102.724C278.581 102.152 277.412 102.244 276.66 102.996C275.803 103.853 275.803 105.246 276.66 106.102Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M248.698 146.475C247.841 145.618 246.448 145.618 245.591 146.475C245.186 146.879 244.974 147.403 244.954 147.932C246.327 147.655 247.689 147.315 249.034 146.907C248.942 146.755 248.834 146.607 248.702 146.475H248.698Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 143.368C252.665 144.229 254.055 144.229 254.916 143.368C255.772 142.512 255.772 141.119 254.916 140.262C254.059 139.406 252.669 139.406 251.809 140.262C250.952 141.119 250.952 142.512 251.809 143.368Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M258.018 137.156C258.875 138.013 260.264 138.013 261.125 137.156C261.982 136.3 261.982 134.907 261.125 134.051C260.268 133.194 258.875 133.194 258.018 134.051C257.162 134.907 257.162 136.3 258.018 137.156Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M264.232 130.946C265.089 131.802 266.478 131.802 267.339 130.946C268.196 130.089 268.196 128.696 267.339 127.84C266.482 126.983 265.089 126.983 264.232 127.84C263.375 128.696 263.375 130.089 264.232 130.946Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M270.45 124.738C271.307 125.594 272.696 125.594 273.557 124.738C274.413 123.881 274.413 122.488 273.557 121.632C272.7 120.775 271.307 120.775 270.45 121.632C269.593 122.488 269.593 123.881 270.45 124.738Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M276.66 115.42C275.803 116.277 275.803 117.67 276.66 118.526C276.888 118.754 277.156 118.918 277.436 119.026C277.885 117.638 278.265 116.229 278.569 114.808C277.893 114.696 277.18 114.9 276.66 115.42Z",
    fill: "#67CFEE"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M364.381 76.0813H364.957C366.218 76.0813 367.247 77.1099 367.247 78.3706V78.947C367.247 80.2077 366.218 81.2363 364.957 81.2363H364.381C363.119 81.2363 362.091 80.2077 362.091 78.947V78.3706C362.091 77.1099 363.119 76.0813 364.381 76.0813ZM375.163 76.9778L375.359 77.5221C375.791 78.7068 377.112 79.3232 378.294 78.891L378.838 78.6948C380.023 78.2626 380.64 76.9418 380.207 75.7611L380.011 75.2168C379.579 74.0321 378.258 73.4157 377.076 73.848L376.532 74.0441C375.347 74.4764 374.73 75.7971 375.163 76.9778ZM386.97 71.1984L387.342 71.6427C388.151 72.6073 389.604 72.7353 390.569 71.9268L391.013 71.5546C391.978 70.7462 392.106 69.2933 391.298 68.3287L390.925 67.8845C390.116 66.9199 388.663 66.7918 387.698 67.6003L387.254 67.9725C386.289 68.781 386.161 70.2339 386.97 71.1984ZM396.086 61.7288L396.586 62.017C397.679 62.6454 399.085 62.2692 399.717 61.1805L400.006 60.6802C400.634 59.5876 400.258 58.1828 399.169 57.5504L398.668 57.2622C397.575 56.6338 396.17 57.0101 395.537 58.0987L395.249 58.599C394.621 59.6917 394.997 61.0965 396.086 61.7288ZM401.415 49.7138L401.983 49.8138C403.225 50.0339 404.418 49.1974 404.638 47.9567L404.738 47.3884C404.958 46.1477 404.121 44.955 402.88 44.7348L402.312 44.6348C401.071 44.4147 399.878 45.2512 399.657 46.4919L399.557 47.0602C399.337 48.3009 400.174 49.4936 401.415 49.7138ZM402.312 36.602L402.88 36.502C404.121 36.2818 404.958 35.0891 404.738 33.8484L404.638 33.2801C404.418 32.0394 403.225 31.2029 401.983 31.423L401.415 31.5231C400.174 31.7432 399.337 32.9359 399.557 34.1766L399.657 34.7449C399.878 35.9857 401.071 36.8222 402.312 36.602ZM398.668 23.9746L399.169 23.6865C400.262 23.0581 400.638 21.6492 400.006 20.5566L399.717 20.0563C399.089 18.9636 397.679 18.5874 396.586 19.2198L396.086 19.508C394.993 20.1363 394.617 21.5451 395.249 22.6378L395.537 23.1381C396.166 24.2307 397.575 24.607 398.668 23.9746ZM390.925 13.3563L391.298 12.9121C392.106 11.9475 391.982 10.4946 391.013 9.68616L390.569 9.31397C389.604 8.5055 388.151 8.62955 387.342 9.59813L386.97 10.0424C386.161 11.007 386.285 12.4598 387.254 13.2683L387.698 13.6405C388.663 14.449 390.116 14.3249 390.925 13.3563ZM380.015 6.02405L380.211 5.47968C380.644 4.29498 380.027 2.97423 378.842 2.54597L378.298 2.34986C377.112 1.91761 375.791 2.53399 375.363 3.71869L375.167 4.263C374.734 5.4477 375.351 6.76846 376.536 7.19671L377.08 7.39282C378.266 7.82508 379.587 7.20875 380.015 6.02405ZM367.255 2.86618V2.28982C367.255 1.02908 366.226 0.000480652 364.965 0.000480652H364.389C363.127 0.000480652 362.099 1.02908 362.099 2.28982V2.86618C362.099 4.12692 363.127 5.15552 364.389 5.15552H364.965C366.226 5.15552 367.255 4.12692 367.255 2.86618ZM354.183 4.259L353.987 3.71468C353.555 2.52998 352.233 1.9136 351.052 2.34586L350.508 2.54197C349.323 2.97422 348.706 4.29503 349.139 5.47572L349.335 6.02004C349.767 7.20474 351.088 7.82107 352.269 7.38882L352.814 7.1927C353.999 6.76045 354.616 5.43969 354.183 4.259ZM342.376 10.0384L342.004 9.59412C341.195 8.62955 339.742 8.50149 338.777 9.30997L338.333 9.68216C337.368 10.4906 337.24 11.9435 338.048 12.9081L338.421 13.3523C339.229 14.3169 340.683 14.445 341.648 13.6365L342.092 13.2643C343.057 12.4558 343.185 11.0029 342.376 10.0384ZM333.26 19.508L332.759 19.2198C331.666 18.5914 330.261 18.9676 329.629 20.0563L329.34 20.5566C328.712 21.6492 329.088 23.0541 330.177 23.6865L330.677 23.9746C331.77 24.603 333.176 24.2267 333.808 23.1381L334.097 22.6378C334.725 21.5451 334.349 20.1403 333.26 19.508ZM327.931 31.5231L327.362 31.423C326.121 31.2029 324.928 32.0394 324.708 33.2801L324.608 33.8484C324.388 35.0891 325.224 36.2818 326.466 36.502L327.034 36.602C328.275 36.8222 329.468 35.9857 329.689 34.7449L329.789 34.1766C330.009 32.9359 329.172 31.7432 327.931 31.5231ZM327.034 44.6348L326.466 44.7348C325.224 44.955 324.388 46.1477 324.608 47.3884L324.708 47.9567C324.928 49.1974 326.121 50.0339 327.362 49.8138L327.931 49.7138C329.172 49.4936 330.009 48.3009 329.789 47.0602L329.689 46.4919C329.468 45.2512 328.275 44.4147 327.034 44.6348ZM330.677 57.2622L330.177 57.5504C329.084 58.1788 328.708 59.5876 329.34 60.6802L329.629 61.1805C330.257 62.2732 331.666 62.6494 332.759 62.017L333.26 61.7288C334.353 61.1005 334.729 59.6917 334.097 58.599L333.808 58.0987C333.18 57.0061 331.77 56.6298 330.677 57.2622ZM338.421 67.8805L338.048 68.3247C337.24 69.2893 337.364 70.7422 338.333 71.5506L338.777 71.9228C339.742 72.7313 341.195 72.6073 342.004 71.6387L342.376 71.1944C343.185 70.2299 343.061 68.777 342.092 67.9685L341.648 67.5963C340.683 66.7878 339.229 66.9119 338.421 67.8805ZM349.331 75.2128L349.135 75.7571C348.702 76.9418 349.319 78.2626 350.504 78.6908L351.048 78.8869C352.233 79.3192 353.555 78.7029 353.983 77.5182L354.179 76.9738C354.612 75.7891 353.995 74.4683 352.81 74.0401L352.265 73.844C351.08 73.4117 349.759 74.0281 349.331 75.2128Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.1155 322.158C-18.3496 320.017 -18.4256 316.471 -16.2836 314.237L184.022 105.31C186.164 103.077 189.711 103.001 191.945 105.142C194.179 107.284 194.255 110.83 192.113 113.063L-8.19215 321.99C-10.3341 324.223 -13.8814 324.299 -16.1155 322.158ZM205.606 90.6537C203.376 88.5165 199.836 88.5925 197.698 90.8218C195.56 93.0511 195.636 96.5892 197.867 98.7265C200.097 100.864 203.636 100.788 205.774 98.5584C207.912 96.3291 207.836 92.791 205.606 90.6537Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 88.8444C167.963 92.8748 168.107 99.5467 164.075 103.753L-212.837 496.893C-216.869 501.095 -223.543 501.239 -227.751 497.209C-231.955 493.179 -232.099 486.507 -228.068 482.3L148.849 89.1606C152.881 84.9581 159.555 84.814 163.763 88.8444H163.759Z",
    fill: "#67CFEE"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M307.748 92.2631C303.18 92.2631 299.476 95.9651 299.476 100.532C299.476 105.099 303.18 108.801 307.748 108.801C312.316 108.801 316.02 105.099 316.02 100.532C316.02 95.9651 312.316 92.2631 307.748 92.2631Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M339.349 56.1937C329.085 56.1937 320.764 64.5117 320.764 74.7726C320.764 85.0335 329.085 93.3516 339.349 93.3516C349.614 93.3516 357.935 85.0335 357.935 74.7726C357.935 64.5117 349.614 56.1937 339.349 56.1937Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomMobileResultPage);
export default __webpack_public_path__ + "static/media/bottomMobileResultPage.f03a33ee3b411559997ca1d5af78284b.svg";
export { ForwardRef as ReactComponent };